import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeWrapper } from './theme';
import App from './App';
import { SessionDataProvider } from './contexts/SessionData';
import { BreakpointsProvider } from './providers/BreakpointsProvider';
import { Auth } from './components/Auth/Auth';
import reportWebVitals from './reportWebVitals';
// import { CheckProfileComplete } from './components/CheckProfileComplete/CheckProfileComplete';
import { ReactQueryProvider } from './providers/ReactQueryProvider';
import { BASENAME } from './config';
import { SnackbarProvider } from './providers/SnackbarProvider';
import { DialogProvider } from './providers/DialogProvider';
import { MfaProvider } from './providers/MfaProvider';
import { initializeGlobalErrorHandlers } from './utils/logger';

// Initialize global error handlers before React renders
initializeGlobalErrorHandlers();

// If this cookie is present then the aut§h0-spa library will attempt a silent login
// If this cookie is not present, then the user starts in an unauthenticated state
// and will be redirected to the dashboard to log in
document.cookie = 'auth0.is.authenticated=true;path=/;max-age=86400';

declare global {
  interface Window {
    _env: any;
    _vite_env: any;
  }
}

ReactDOM.render(
  <ThemeWrapper>
    <CssBaseline />
    <MfaProvider>
      <SnackbarProvider>
        <DialogProvider>
          <SessionDataProvider>
            <Auth>
              <ReactQueryProvider>
                {/*<CheckProfileComplete>*/}
                <BreakpointsProvider>
                  <BrowserRouter basename={BASENAME}>
                    <App />
                  </BrowserRouter>
                </BreakpointsProvider>
                {/*</CheckProfileComplete>*/}
              </ReactQueryProvider>
            </Auth>
          </SessionDataProvider>
        </DialogProvider>
      </SnackbarProvider>
    </MfaProvider>
  </ThemeWrapper>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
